import { render, staticRenderFns } from "./AdvisorSystem.vue?vue&type=template&id=6ba21b22"
import script from "./AdvisorSystem.vue?vue&type=script&lang=ts"
export * from "./AdvisorSystem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports